import React, { forwardRef, Ref, SVGProps } from 'react'

function _IconFrameLogIn(props: SVGProps<SVGSVGElement>, ref?: Ref<SVGSVGElement>) {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" {...props} ref={ref}>
      <rect x="0.800003" width="24" height="24" rx="6" fill={props.fill ?? '#F2F5F7'} />
      <path
        d="M13.7 7.5H15.7C15.9652 7.5 16.2196 7.60536 16.4071 7.79289C16.5947 7.98043 16.7 8.23478 16.7 8.5V15.5C16.7 15.7652 16.5947 16.0196 16.4071 16.2071C16.2196 16.3946 15.9652 16.5 15.7 16.5H13.7"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.2 14.5L13.7 12L11.2 9.49998"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7 12H7.70001"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const IconFrameLogIn = forwardRef(_IconFrameLogIn)
